import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useCostCentersMutations } from 'modules/finance/hooks/useCostCentersMutations'
import {
  FormattedAssignment,
  FormattedAssignmentWithDeletion,
} from 'modules/finance/lib/costCenterAssignments'

import { SaveButton } from './SaveButton'

interface Props {
  assignmentsToCreate: FormattedAssignment[]
  assignmentsToUpdate: FormattedAssignmentWithDeletion[]
  disabled: boolean
  resourceId: number
  onSave?: () => void
}

export const UpdateButton = ({
  assignmentsToCreate,
  assignmentsToUpdate,
  disabled,
  resourceId,
  onSave,
}: Props) => {
  const { company } = useCurrentSession()
  const { save } = useCostCentersMutations()

  const handleOnClick = async () => {
    const successSave = await save({
      assignmentsToCreate: assignmentsToCreate.map((assignment) => {
        return {
          costCenterId: Number(assignment.costCenterId),
          percentage: assignment.percentage,
          startDate: assignment.startDate,
          endDate: assignment.endDate === '' ? null : assignment.endDate,
          companyId: company.id,
          employeeId: resourceId,
        }
      }),
      assignmentsToUpdate: assignmentsToUpdate.map((assignment) => {
        return {
          costCenterId: Number(assignment.costCenterId),
          percentage: assignment.percentage,
          startDate: assignment.startDate,
          endDate: assignment.endDate === '' ? null : assignment.endDate,
          id: Number(assignment.id),
          markedForDeletion: !!assignment.markedForDeletion,
        }
      }),
    })

    if (successSave) {
      onSave?.()
    }
  }

  return <SaveButton disabled={disabled} onSave={handleOnClick} />
}
